import * as React from "react";

const TelegramIconBrand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#26A5E4" />
    <path
      d="M20.4533 10C17.8093 10.0124 15.2777 11.0714 13.4124 12.9454C11.5471 14.8194 10.5 17.3559 10.5 20C10.5 22.6522 11.5536 25.1957 13.4289 27.0711C15.3043 28.9465 17.8478 30 20.5 30C23.1522 30 25.6957 28.9465 27.5711 27.0711C29.4464 25.1957 30.5 22.6522 30.5 20C30.5 17.3479 29.4464 14.8043 27.5711 12.929C25.6957 11.0536 23.1522 10 20.5 10C20.4844 9.99999 20.4689 9.99999 20.4533 10ZM24.5883 16.02C24.6717 16.0184 24.8558 16.0392 24.9758 16.1367C25.0556 16.2059 25.1064 16.3026 25.1183 16.4075C25.1317 16.485 25.1483 16.6625 25.135 16.8009C24.985 18.3825 24.3333 22.2192 24.0017 23.99C23.8617 24.74 23.5858 24.9909 23.3183 25.015C22.7383 25.0692 22.2975 24.6317 21.735 24.2634C20.855 23.6859 20.3575 23.3267 19.5033 22.7634C18.5158 22.1134 19.1558 21.755 19.7183 21.1717C19.8658 21.0184 22.4242 18.6909 22.4742 18.48C22.48 18.4534 22.4858 18.355 22.4275 18.3034C22.3692 18.2517 22.2825 18.2692 22.22 18.2834C22.1317 18.3034 20.7258 19.2334 18.0025 21.0709C17.6025 21.3459 17.2417 21.4792 16.9175 21.4709C16.5608 21.4642 15.8742 21.27 15.3633 21.1042C14.7367 20.9 14.2392 20.7925 14.2825 20.4467C14.305 20.2667 14.5533 20.0825 15.0267 19.8942C17.9417 18.6242 19.885 17.7867 20.8583 17.3825C23.635 16.2275 24.2125 16.0267 24.5883 16.02Z"
      fill="white"
    />
  </svg>
);

export default TelegramIconBrand;
